import React from 'react';

import qs from 'qs';
import { FormattedMessage } from 'react-intl';

import { useIntl } from 'src/hooks/intl';
import { Link } from 'src/router/components';

import nothingFoundImgUrl from '../search-nothing-found.svg';
import SyntaxHint from '../syntax-hint/syntax-hint';

import messages from './no-results-state.i18n';
import * as styles from './no-results-state.style';

type NoResultsStateProps = {
  syntaxError: 'OPERATOR' | 'EXTENSION' | null;
  accountUuid: string;
  query: string;
};

export const NoResultsState: React.FC<NoResultsStateProps> = props => {
  const intl = useIntl();
  const { syntaxError, query, accountUuid } = props;
  return (
    <styles.Centered>
      <styles.ImageContainer>
        <img alt="" src={nothingFoundImgUrl} role="presentation" />
      </styles.ImageContainer>
      <h4>
        <FormattedMessage {...messages.noResultsHeading} />
      </h4>
      <styles.Description>
        {syntaxError === 'EXTENSION' ? (
          <SyntaxHint syntaxError={syntaxError} />
        ) : (
          <FormattedMessage
            {...messages.noResultsDescription}
            values={{
              codeSearchLink: (
                <Link
                  to={`/search?${qs.stringify({
                    account: accountUuid,
                    q: query,
                  })}`}
                >
                  {intl.formatMessage(messages.noResultsCodeSearchLinkLabel)}
                </Link>
              ),
            }}
          />
        )}
      </styles.Description>
    </styles.Centered>
  );
};
